import React from 'react';
import styles from './notFound.module.scss';

function NotFound() {
    return (
        <>
            <div className={styles['main-content-wrapper']}>
                <div className={styles['main-left-content']}>
                    <h1 className={styles.title}>
                        404 Page Not Found
                    </h1>
                    <div className={styles.content}>
                        <p>
                            We can't seem to locate the page you're
                            looking for.
                        </p>
                    </div>
                </div>
                <div className={styles['main-right-content']} />
            </div>
        </>
    );
}

export default NotFound;
